module.exports = __webpack_public_path__ + "img/sao_paulo@2x.d1961f62.png";